import { GrafanaFolder, GrafanaFolderUpdateRequest } from '../../types/app/grafanaFolder.types';
import { api } from '../core/api';

/* export const getList = (limit?: number) =>
  limit
    ? api.get<GrafanaFolder[]>(`GrafanaFolder/GetList?limit=${limit}`).then((res) => res.data)
    : api.get<GrafanaFolder[]>('GrafanaFolder/GetList').then((res) => res.data); */
export const getList = () =>
  api.get<GrafanaFolder[]>('GrafanaFolder/GetList').then((res) => res.data);

export const getItem = (uid: number) =>
  api.get<GrafanaFolder>(`GrafanaFolder/GetItem?uid=${uid}`).then((res) => res.data);

export const updateItem = (data: GrafanaFolderUpdateRequest) =>
  api.put(`GrafanaFolder/Update?uid=${data.uid}`, data).then((res) => res.data);

/* export const createItem = (data: GrafanaFolderCreateRequest) =>
  api
    .post(`GrafanaFolder/Create`, data.name, config)
    .then((res) => res.data.headers['Content-Type']); */

export const deleteItem = (uid: string) => api.delete(`GrafanaFolder/Delete?uid=${uid}`).then();
